import React from 'react';
import Input from '../components/Input';
import Accordion from '../components/Accordion';
import DnsOutlinedIcon from '@mui/icons-material/DnsOutlined';
import ChannelSettings from './ChannelSettings';
import { initialConfiguration } from '../features/Devices/constants/constants';
import ControllerFormFields from './ControllerFormFields';

const ControllerEditor = ({ setDeviceToEdit, deviceToEdit, devices, deviceInputs, setDeviceInputs }) => {
  const [accordion, setAccordion] = React.useState({ 0: true });

  return (
    <>
      <Accordion accordion={accordion} setAccordion={setAccordion} id={'one'} Icon={DnsOutlinedIcon} name={'Общие настройки'}>
        <div className="px-0 sm:px-4 lg:px-5 xl:px-8 2xl:px-10">
          <Input
            classContainer={'w-full'}
            value={deviceToEdit.serial_number}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                serial_number: e.target.value,
              })
            }
            label="Серийный номер"
            id="type"
            type="text"
            placeholder={'A123'}
          />
          <Input
            classContainer={'w-full mt-4'}
            value={deviceToEdit.description}
            inputCb={(e) =>
              setDeviceToEdit({
                ...deviceToEdit,
                description: e.target.value,
              })
            }
            label="Место установки устройства"
            id="descr"
            type="text"
            placeholder={'Например: ванная, санузел, кухня'}
          />
          <ControllerFormFields deviceToEdit={deviceToEdit} setDeviceToEdit={setDeviceToEdit} />
        </div>
      </Accordion>
      <ChannelSettings
        setDeviceInputs={setDeviceInputs}
        initialConfiguration={initialConfiguration}
        deviceInputs={deviceInputs}
        devices={devices}
        deviceToEdit={deviceToEdit}
      />
    </>
  );
};

export default ControllerEditor;
